// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
// material
import {
  Container,
  Stack,
  Typography,
  Button,
  TextField,
  Tooltip,
  MenuItem,
  Select,
} from '@mui/material';
import Box from '@mui/material/Box';
// components
import Page from '../components/Page';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  useFindServiceProviderDetailByIdMutation,
  useUpdateServiceProviderDetailMutation,
  useUploadFormMutation,
} from '../store/api/serviceProviderApi';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useGetEnumDataMutation } from '../store/api/enumApi';
import { getSpecificEnumData, setEnumData } from '../store/state/enumSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Loading from '../components/Loading';
import ibutton from '../../src/assets/static/mock-images/logo/ibutton.png';
import { splitName } from '../sections/@dashboard/parkingspaces/utility';
import DeleteIcon from '@mui/icons-material/Delete';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {
  useUploadServiceProviderDocMutation,
  useFindByParkingLocationIdDocMutation,
  useDeleteServiceProviderDocMutation
} from '../store/api/uploadDocumentApi';

// ----------------------------------------------------------------------
const ServiceProviderSchema = Yup.object().shape(
  {
    name: Yup.string().required('Name is required').trim(),
    contactNumber: Yup.string()
      .required('This field is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Phone number is not valid'
      )
      .min(10, 'Contact Number must be 10 digits')
      .max(10, 'Contact Number must be 10 digits')
      .trim(),
    secondaryContactNumber: Yup.string()
      .required('Alternative contact number is required')
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Please enter a valid phone number'
      )
      .min(10, 'Alternative contact number must be 10 digits')
      .max(10, 'Alternative contact number must be 10 digits')
      .trim(),
    emailId: Yup.string().email('Invalid email').required('Email is required').trim(),
    businessName: Yup.string().required('Business name is required').trim(),
    address: Yup.string().required('Address is required').trim(),
    city: Yup.string().required('City is required').trim(),
    state: Yup.string().required('State is required').trim(),
    country: Yup.string().required('Country is required').trim(),
    ZIPCode: Yup.string().required('ZIP Code is required').trim(),
    listAccountNumber: Yup.string()
      .optional()
      .nullable()
      .matches(/^[0-9]+(\.?[0-9]+)?$/, {
        message: 'List Account Number must be number',
      })
      .trim(),
    // listAccountNumber: Yup.string()
    //   .optional()
    //   .nullable()
    //   .matches(/^[0-9]+(\.?[0-9]+)?$/, {
    //     message: 'List Account Number must be number',
    //   })
    //   .trim(),
    aadharCard: Yup.string()
      .required(' Aadhar is required')
      .matches(/^\d{4}\d{4}\d{4}$/, '  Aadhar number is not valid')
      .trim(),
    employerIdentificationNumber: Yup.string()
      .required(' Pan Card number is required')
      .matches(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/, ' Pan Card number is not valid')
      .trim(),
    gstNo: Yup.string()
      .required(' GST is required')
      .matches(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/, ' GST is not valid')
      .trim(),
    companyTypeList: Yup.string().required('Select atleast one option'),
    businessType: Yup.string().required('Select atleast one option'),
    accountType: Yup.string().required('Select atleast one option'),
    // taxClassification: Yup.string()
    //   .when('companyTypeList', {
    //     is: (companyTypeList: any) => companyTypeList == 'CTMLLC',
    //     then: Yup.string()
    //       .required('Field is required')
    //       .matches(/[C S P]/, { message: 'Only alphabets C, S, P are allowed for this field' }),
    //     otherwise: Yup.string(),
    //   })
    //   .trim(),
    commission: Yup.string()
      .required('Commission is required')
      .matches(/^[0-9]+(\.?[0-9]+)?$/, { message: 'Invalid number' })
      .trim(),
    // convenienceFee: Yup.string()
    //   .required('Convenience Fee is required')
    //   .matches(/^[0-9]+(\.?[0-9]+)?$/, { message: 'Invalid number' })
    //   .trim(),
    cinNumber: Yup.string()
      .required('CIN is required')
      .matches(
        /^[LUlu]\d{5}[A-Za-z]{2}\d{4}[A-Za-z]{3}\d{6}$/,
        'Enter a valid CIN'
      ),
    bankName: Yup.string()
      .required('Bank name is required'),

    bankRecipientName: Yup.string()
      .required('Recipient name is required'),

    bankIfscCode: Yup.string()
      .required('IFSC code is required')
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code'),

    listAccountNumber: Yup.string()
      .required('Account number is required')
      .matches(/^\d{9,18}$/, 'Account number must be 9 to 18 digits'),
  },

);

export default function Account() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: '',
    contactNumber: '',
    bankName: '',
    bankRecipientName: '',
    bankAccountType: '',
    bankIfscCode: '',
    emailId: '',
    businessName: '',
    address: '',
    city: '',
    state: '',
    country: '',
    zip: '',
    primaryAccountNo: '',
    socialSecNumber: '',
    taxClassification: '',
    other: '',
    einNumber: '',
    companyTypeList: '',
    status: false,
    filePath: '',
    sendEmail: false,
    aadhaarNumber: '',
    convenienceFee: '',
    secondaryContactNumber: '',
    cinNumber: '',
    accountType: '',
    businessType: '',
  });
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const [values, setValues] = useState({});
  const [findServiceProviderDetailById, findByIdResponse] = useFindServiceProviderDetailByIdMutation();
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [checkData, setcheckData] = useState([]);
  const [updateServiceProviderDetail, serviceProviderDetailResponse] = useUpdateServiceProviderDetailMutation();
  const [filePath, setFilePath] = useState(false);
  const fileInputForW9: any = useRef();
  const [selectedFile, setSelectedFile] = useState<null | any>();
  const { state }: any = useLocation();
  const [other, setOther] = useState();
  const [allDisabled, setAllDisabled] = useState(false);

  const [checkDataT, setCheckDataT] = useState('');
  const [contractFilePath, setContractFilePath] = useState('');
  const [uploadForm, uploadFormResponse] = useUploadServiceProviderDocMutation();
  const [getDocumentForm, getDocumentResponse] = useFindByParkingLocationIdDocMutation();
  const [deleteDocument, deleteDocumentRes] = useDeleteServiceProviderDocMutation();
  const [w9FilePath, setW9FilePath] = useState([]);
  const [selectedFileForW9, setSelectedFileForW9] = useState<null | any>();
  const [PanCardUrl, setPanCardUrl]: any = useState()
  const [GSTUrl, setGSTdUrl] = useState()
  const [AaharUrl, setAahardUrl] = useState()
  const [contractUrl, setContractdUrl] = useState()
  const [isImgUrl, setIsImgUrl] = useState();
  const [businessType, setBusinessType] = useState([]);
  const [accountType, setAccountType] = useState([]);

  useEffect(() => {
    getDocumentForm({ token: token.token, serviceProviderId: token.serviceProviderId });
  }, [])

  useEffect(() => {
    findServiceProviderDetailById({ id: token.serviceProviderId, token: token.token });
  }, []);

  useEffect(() => {
    getEnumData({ token: token.token });
  }, []);

  useEffect(() => {
    if (deleteDocumentRes.isSuccess) {
      toast.success('Records deleted successfully');
      getDocumentForm({ token: token.token, serviceProviderId: token.serviceProviderId });
    }
  }, [deleteDocumentRes.isSuccess])

  useEffect(() => {
    if (getDocumentResponse.isSuccess) {
      setW9FilePath(getDocumentResponse.data)

      getDocumentResponse.data && getDocumentResponse.data.filter(item => {
        if (item.docType === "PANCARD") {

          setPanCardUrl(item.filePreSignedUrl)
        }
      })
      getDocumentResponse.data && getDocumentResponse.data.filter(item => {
        if (item.docType === "GST") {

          setGSTdUrl(item.filePreSignedUrl)
        }
      })
      getDocumentResponse.data && getDocumentResponse.data.filter(item => {
        if (item.docType === "AADHAR") {

          setAahardUrl(item.filePreSignedUrl)
        }
      })
      getDocumentResponse.data && getDocumentResponse.data.filter(item => {
        if (item.docType === "CONTRACT") {

          setContractdUrl(item.filePreSignedUrl)
        }
      })
      getDocumentResponse.data && getDocumentResponse.data.filter(item => {
        if (item.docType === "COMPANY_LOGO") {

          setIsImgUrl(item.filePreSignedUrl)
        }
      })
    }
  }, [getDocumentResponse.isSuccess, getDocumentResponse.isError])


  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      setcheckData(enumData['COMPANY_TYPE']);
      setBusinessType(enumData['BUSINESS_TYPE'])
      setAccountType(enumData['ACCOUNT_TYPE'])
    }
  }, [enumData]);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      let custData = findByIdResponse.data;
      console.log(custData ,"custData");
      setFormValues(custData);
      if (custData?.currentStatus == 'Approved') {
        setAllDisabled(true);
      }
      setValues(findByIdResponse.data);
      setContractFilePath(findByIdResponse.data.contractFilePath);
    }
  }, [findByIdResponse.isSuccess]);

  const updateServiceProvider = async (values: any, action: any) => {
    let newValues = values
    newValues.sendEmail = true;
    await updateServiceProviderDetail({
      payload: newValues,
      token: token.token,
    });
  };

  useEffect(() => {
    if (serviceProviderDetailResponse.isSuccess) {
      toast.success('Records updated successfully');
    }
  }, [serviceProviderDetailResponse.isSuccess]);

  const changeHandlerForAdhar = (event: any) => {
    const fileName = event.target.files[0].name
    const extention = fileName.lastIndexOf(".") + 1;
    const extFile = fileName.substr(extention, fileName.length).toLowerCase();
    if (extFile === "jpg" || extFile === "jpeg" || extFile === "png" || extFile === "pdf" || extFile === "docx" || extFile === "pdf") {
      setSelectedFileForW9(event.target.files[0]);
    } else {
      setSelectedFileForW9(null);
      toast.error("Only *.jpeg, *.jpg, *.png, *.pdf, *.docx files are allowed!");
    }

  };

  const changeHandlerProfileImage = (event: any) => {
    const fileName = event.target.files[0].name
    const extention = fileName.lastIndexOf(".") + 1;
    const extFile = fileName.substr(extention, fileName.length).toLowerCase();
    if (extFile === "jpg" || extFile === "jpeg" || extFile === "png") {
      setSelectedFileForW9(event.target.files[0]);
    } else {
      setSelectedFileForW9(null);
      toast.error("Only *.jpeg, *.jpg, *.png files are allowed!");
    }

  };

  const uploadFileForW9 = (docType: any) => {
    if (selectedFileForW9 !== null) {
      const formData = new FormData();
      formData.append('file', selectedFileForW9);
      const values = [...formData.entries()];
      uploadForm({
        file: formData,
        serviceProviderId: token.serviceProviderId,
        docType: docType,
        token: token.token,
      });
    }

  };

  const uploadFileForContract = (value: any) => {
    const formData = new FormData();
    formData.append('file', selectedFile);
    const values = [...formData.entries()];
    uploadForm({
      payload: formData,
      serviceProviderId: formValues.id,
      docType: value,
      token: token.token,
    });
  };

  useEffect(() => {
    if (uploadFormResponse.isSuccess) {
      fileInputForW9.current.value = ''
      getDocumentForm({ token: token.token, serviceProviderId: token.serviceProviderId });
      toast.success('File added successfully');
    }
  }, [uploadFormResponse.isSuccess]);

  return (
    <Page title="Account Detail">
      <h1
        style={{
          marginLeft: '20px',
        }}
      >
        Account Detail
      </h1>
      <Formik
        enableReinitialize
        initialValues={formValues}
        onSubmit={updateServiceProvider}
        validationSchema={ServiceProviderSchema}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <Container
            sx={{
              paddingTop: '2rem',
              paddingBottom: '2rem',
            }}
          >
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Full Name
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter name"
                    name={'name'}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Business Name
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter business name"
                    name={'businessName'}
                    value={values.businessName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.businessName && errors.businessName)}
                    helperText={touched.businessName && errors.businessName}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Phone Number
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter contact number"
                    name={'contactNumber'}
                    value={values.contactNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.contactNumber && errors.contactNumber)}
                    helperText={touched.contactNumber && errors.contactNumber}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's  Alternative Phone Number
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter vendor alternative phone number"
                    name={'secondaryContactNumber'}
                    value={values.secondaryContactNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.secondaryContactNumber && errors.secondaryContactNumber)}
                    helperText={touched.secondaryContactNumber && errors.secondaryContactNumber}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Typography variant="h5" marginTop={2} gutterBottom component="div">
                Please select the appropriate option for the tax classification of the entity as per Indian tax regulations.
              </Typography>
              <Select
                name="companyTypeList"
                id="companyTypeList"
                // key={values.companyTypeList}
                value={values.companyTypeList}
                className='w-[300px] md:w-[500px]'
                disabled={allDisabled}
                onChange={(event: any) => {
                  setCheckDataT(event.target.value);
                  setFieldValue('companyTypeList', event.target.value);
                }}
                displayEmpty
                defaultValue={''}
              >
                <MenuItem disabled value="">
                  Select Option
                </MenuItem>
                {checkData &&
                  checkData.map((checkData: any) => (
                    <MenuItem
                      key={checkData.code} value={checkData.code}
                    >
                      {checkData.displayValue}
                    </MenuItem>
                  ))}
              </Select>
              {errors.companyTypeList && <div style={{ color: 'red' }} className="text-sm">{errors.companyTypeList}</div>}
              {/* {errors.companyTypeList == 'CTMLLC' || checkDataT ==
                "CTMLLC" && (
                  <Box width={"100%"}>
                    <Box className=" " style={{ display: 'flex', gap: '10px' }}>
                      <Typography variant="h6" gutterBottom component="div">
                        Tax classification
                      </Typography>
                      <Tooltip
                        title="Note: Select the appropriate option in the line above
                        for the tax classification of the
                        single-member owner. Do not select LLC if the
                        LLC is classified as a single-member LLC
                        that is disregarded from the owner unless
                        the owner of the LLC is another LLC that is
                        not disregarded from the owner for Indian
                        federal tax purposes. Otherwise, a
                        single-member LLC that is disregarded from
                        the owner should select the appropriate option
                        for the tax classification of its owner."
                        placement="right-end"
                      >
                        <img style={{ height: '20px', marginTop: '5px' }} src={ibutton} />
                      </Tooltip>
                    </Box>

                    <Stack direction="column" alignItems="self-start">
                      <TextField
                        sx={{ width: "100%" }}
                        placeholder="Taxclassification"
                        name={"taxClassification"}
                        value={values.taxClassification}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.taxClassification && errors.taxClassification)}
                        helperText={touched.taxClassification && errors.taxClassification}
                      />
                    </Stack>
                  </Box>
                )
              } */}
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Typography variant="h5" gutterBottom component="div">
                  Vendor's Address
                </Typography>
                <Stack direction="column" alignItems="self-start">
                  <TextField
                    sx={{ width: '90%' }}
                    placeholder="Enter address"
                    name={'address'}
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.address && errors.address)}
                    helperText={touched.address && errors.address}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Email
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter emailId"
                    name={'emailId'}
                    value={values.emailId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.emailId && errors.emailId)}
                    helperText={touched.emailId && errors.emailId}
                    disabled={true}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    City Name
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter city"
                    name={'city'}
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.city && errors.city)}
                    helperText={touched.city && errors.city}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Box width="100%">
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      State Name
                    </Typography>
                    <TextField
                      sx={{ width: '80%' }}
                      placeholder="Enter state"
                      name={'state'}
                      value={values.state}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.state && errors.state)}
                      helperText={touched.state && errors.state}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Country Name
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter country"
                    name={'country'}
                    value={values.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.country && errors.country)}
                    helperText={touched.country && errors.country}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Postal Code
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="Enter zipcode"
                    name={'zip'}
                    value={values.zip}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.zip && errors.zip)}
                    helperText={touched.zip && errors.zip}
                    disabled={allDisabled}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Bank Name
                  </Typography>
                  <TextField
                    disabled={allDisabled}
                    sx={{ width: '80%' }}
                    placeholder="Bank Name (Optional)"
                    name={'bankName'}
                    value={values.bankName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  // error={Boolean(touched.bankName && errors.bankName)}
                  // helperText={touched.bankName && errors.bankName}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vendor's Bank Account Number
                  </Typography>
                  <TextField
                    disabled={allDisabled}
                    sx={{ width: '90%' }}
                    placeholder="Enter vendor Bank Account No..."
                    name={'primaryAccountNo'}
                    value={values.primaryAccountNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.primaryAccountNo && errors.primaryAccountNo)}
                    helperText={touched.primaryAccountNo && errors.primaryAccountNo}
                  />
                </Stack>
              </Box>

            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    IFSC Code
                  </Typography>
                  <TextField
                    disabled={allDisabled}
                    sx={{ width: '80%' }}
                    placeholder="IFSC Code (Optional)"
                    name={'bankIfscCode'}
                    value={values.bankIfscCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  // error={Boolean(touched.ZIPCode && errors.ZIPCode)}
                  // helperText={touched.ZIPCode && errors.ZIPCode}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Recipient Name
                  </Typography>
                  <TextField
                    disabled={allDisabled}
                    sx={{ width: '90%' }}
                    placeholder="Recipient Name (Optional)"
                    name={'bankRecipientName'}
                    value={values.bankRecipientName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Stack>
              </Box>

            </Box>
            <Box display="flex" alignItems="center" marginTop={'25px'} >
              <Box width="100%">
                <Typography variant="h5" gutterBottom component="div">
                  Account Type
                </Typography>
                <Select
                  name="accountType"
                  id="accountType"
                  value={
                    values.accountType
                  }
                  className="w-[300px] md:w-[500px]"
                  disabled={allDisabled}
                  onChange={(event: any) => {
                    setFieldValue('accountType', event.target.value);
                  }}
                  error={Boolean(touched.accountType && errors.accountType)}
                  displayEmpty
                  defaultValue=""
                  sx={{ width: '80%' }}
                >
                  <MenuItem disabled value="">
                    Select Option
                  </MenuItem>
                  {accountType?.map((item: any) => (
                    <MenuItem key={item.code} value={item.code}>
                      {item.displayValue}
                    </MenuItem>
                  ))}
                </Select>
                {errors.accountType && (
                  <Typography color="error" variant="body2">
                    {errors.accountType}
                  </Typography>
                )}
              </Box>
              <Box width="100%">
                <Typography variant="h5" gutterBottom component="div">
                  Business Type
                </Typography>
                <Select
                  name="businessType"
                  id="businessType"
                  value={
                   
                       values.businessType
                  }
                  className="w-[300px] md:w-[500px]"
                  disabled={allDisabled}
                  onChange={(event: any) => {
                    setFieldValue('businessType', event.target.value);
                  }}
                  error={Boolean(touched.businessType && errors.businessType)}
                  displayEmpty
                  defaultValue=""
                  sx={{ width: '80%' }}
                >
                  <MenuItem disabled value="">
                    Select Option
                  </MenuItem>
                  {businessType?.map((item: any) => (
                    <MenuItem key={item.code} value={item.code}>
                      {item.displayValue}
                    </MenuItem>
                  ))}
                </Select>
                {errors.businessType && (
                  <Typography color="error" variant="body2">
                    {errors.businessType}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    CIN Number
                  </Typography>
                  <TextField
                    sx={{ width: '80%' }}
                    placeholder="CIN Number"
                    name={'cinNumber'}
                    name={'cinNumber'}
                    value={values.cinNumber}
                    disabled={allDisabled}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.cinNumber && errors.cinNumber)}
                    helperText={touched.cinNumber && errors.cinNumber}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Bank Account Type
                  </Typography>
                  <FormControl disabled={allDisabled}>
                    <RadioGroup
                      aria-labelledby="bankAccountType"
                      value={values.bankAccountType}
                      name="bankAccountType"
                      onChange={handleChange}
                    >
                      <FormControlLabel value="SAVING_ACCOUNT" control={<Radio />} label="Saving Account " />
                      <FormControlLabel value="CURRENT_ACCOUNT" control={<Radio />} label="Current Account" />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} alignItems={'start'} marginTop={'25px'}>
                <Box width={{ xs: '100%', sm: '50%' }}>
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Vendor's GST Identification
                    </Typography>
                    <TextField
                      sx={{ width: '82%' }}
                      placeholder="Enter socialSecurityNumber"
                      name={'socialSecNumber'}
                      value={values.socialSecNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.socialSecurityNumber && errors.socialSecNumber)}
                      helperText={touched.socialSecNumber && errors.socialSecNumber}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>
                <Box width={{ xs: '100%', sm: '50%' }} marginTop={{ xs: '20px', sm: '0' }}>
                  <Box alignItems={'center'} marginTop={'10px'}>
                    <Box width="100%">
                      <Stack direction="column" alignItems="self-start">
                        <Typography variant="h5" gutterBottom component="div">
                          GST Upload
                        </Typography>
                      </Stack>
                    </Box>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: '10px',
                        width: '100%',
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: 'column', width: '100%' }}>
                        <div>
                          <input
                            id="input"
                            type="file"
                            accept=".png, .jpg, .jpeg , .pdf, .docx"
                            name="file"
                            ref={fileInputForW9}
                            onChange={(e) => {
                              changeHandlerForAdhar(e);
                            }}
                          />
                        </div>

                        <div>
                          {GSTUrl === null && (
                            <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                          )}
                          <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx</p>
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: 'row', width: '100%' }}>
                        <div style={{ width: '100%' }}>
                          {GSTUrl !== null && (
                            <div>
                              <td
                                style={{
                                  color: 'blue',
                                  width: '28%',
                                  cursor: 'pointer',
                                }}
                                onClick={() => window.open(GSTUrl, "_blank")}
                                href={GSTUrl}
                              >
                                Download GST
                              </td>
                            </div>
                          )}
                        </div>

                        <div style={{ width: '100%' }}>
                          <Button
                            style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                            variant="contained"
                            color="error"
                            onClick={() => {
                              uploadFileForW9('GST');
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} alignItems={'start'} marginTop={'25px'}>
                <Box width={{ xs: '100%', sm: '50%' }}>
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Vendor's PAN Card
                    </Typography>
                    <TextField
                      sx={{ width: '82%' }}
                      placeholder="Enter vendor einNumber"
                      name={'einNumber'}
                      value={values.einNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.einNumber && errors.einNumber)}
                      helperText={touched.einNumber && errors.einNumber}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>

                <Box width={{ xs: '100%', sm: '50%' }} marginTop={{ xs: '20px', sm: '0' }}>
                  <Box alignItems={'center'} marginTop={'10px'}>
                    <Box width="100%">
                      <Stack direction="column" alignItems="self-start">
                        <Typography variant="h5" gutterBottom component="div">
                          PAN Card Upload
                        </Typography>
                      </Stack>
                    </Box>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap', // Ensures wrapping on small screens
                        gap: '10px',
                        width: '100%',
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: 'column', width: '100%' }}>
                        <div>
                          <input
                            id="input"
                            type="file"
                            accept=".png, .jpg, .jpeg , .pdf, .docx"
                            name="file"
                            ref={fileInputForW9}
                            onChange={(e) => {
                              changeHandlerForAdhar(e);
                            }}
                          />
                        </div>

                        <div>
                          {PanCardUrl === null && (
                            <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                          )}
                          <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx</p>
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: 'row', width: '100%' }}>
                        <div style={{ width: '100%' }}>
                          {PanCardUrl !== null && (
                            <div>
                              <td
                                style={{
                                  color: 'blue',
                                  width: '28%',
                                  cursor: 'pointer',
                                }}
                                onClick={() => window.open(PanCardUrl, "_blank")}
                                href={PanCardUrl}
                              >
                                Download Pan Card
                              </td>
                            </div>
                          )}
                        </div>

                        <div style={{ width: '100%' }}>
                          <Button
                            style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                            variant="contained"
                            color="error"
                            onClick={() => {
                              uploadFileForW9('PANCARD');
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} alignItems={'start'} marginTop={'25px'}>
                <Box width={{ xs: '100%', sm: '50%' }}>
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Vendor's Aadhar Card
                    </Typography>
                    <TextField
                      sx={{ width: '82%' }}
                      placeholder="Vendor's Aadhar Card"
                      name={'aadharCard'}
                      value={values.aadhaarNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.aadhaarNumber && errors.aadhaarNumber)}
                      helperText={touched.aadhaarNumber && errors.aadhaarNumber}
                      disabled={allDisabled}
                    />
                  </Stack>
                </Box>

                <Box width={{ xs: '100%', sm: '50%' }} marginTop={{ xs: '20px', sm: '0' }}>
                  <Box alignItems={'center'} marginTop={'10px'}>
                    <Box width="100%">
                      <Stack direction="column" alignItems="self-start">
                        <Typography variant="h5" gutterBottom component="div">
                          Aadhar Card Upload
                        </Typography>
                      </Stack>
                    </Box>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap', // Ensures wrapping on small screens
                        gap: '10px',
                        width: '100%',
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: 'column', width: '100%' }}>
                        <div>
                          <input
                            id="input"
                            type="file"
                            accept=".png, .jpg, .jpeg , .pdf, .docx"
                            name="file"
                            ref={fileInputForW9}
                            onChange={(e) => {
                              changeHandlerForAdhar(e);
                            }}
                          />
                        </div>

                        <div>
                          {AaharUrl === null && (
                            <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                          )}
                          <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx</p>
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: 'row', width: '100%' }}>
                        <div style={{ width: '100%' }}>
                          {AaharUrl !== null && (
                            <div>
                              <td
                                style={{
                                  color: 'blue',
                                  width: '28%',
                                  cursor: 'pointer',
                                }}
                                onClick={() => window.open(AaharUrl, "_blank")}
                                href={AaharUrl}
                              >
                                Download Aadhar Card
                              </td>
                            </div>
                          )}
                        </div>

                        <div style={{ width: '100%' }}>
                          <Button
                            style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                            variant="contained"
                            color="error"
                            onClick={() => {
                              uploadFileForW9('AADHAR');
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ marginTop: '25px' }}>
              <Box alignItems={'center'} marginTop={'10px'} >
                <Box width="50%">
                  <Stack direction="column" alignItems="self-start">
                    <Typography variant="h5" gutterBottom component="div">
                      Contract Upload
                    </Typography>
                  </Stack>
                </Box>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '10px',
                  }}
                >
                  <div style={{ display: "flex", flexDirection: 'column' }}>
                    <div>
                      <input
                        id="input"
                        type="file"
                        accept=".png, .jpg, .jpeg , .pdf, .docx"
                        name="file"
                        ref={fileInputForW9}
                        onChange={(e) => {
                          changeHandlerForAdhar(e)
                        }}
                      />
                    </div>

                    <div>

                      {contractUrl === null &&
                        <p style={{ marginTop: '5px', fontSize: '11px', color: 'red' }}>Please Upload File</p>
                      }
                      <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed *.jpeg, *.jpg, *.png, *.pdf, *.docx</p>
                    </div>
                  </div>

                  <div>
                    {contractUrl !== null &&
                      <div>
                        <td style={{
                          color: 'blue',
                          width: '28%',
                          cursor: 'pointer'
                        }}
                          onClick={() => window.open(contractUrl, "_blank")} href={contractUrl}
                        >Download Contract</td>

                      </div>
                    }
                  </div>
                  <div>
                    <Button
                      style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                      variant="contained"
                      color="error"
                      onClick={() => {
                        uploadFileForW9('CONTRACT');
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </Box>
            </Box>
            <Box style={{ marginTop: '10px' }}>
              <Box width="50%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Company Logo
                  </Typography>
                </Stack>
              </Box>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: '10px',
                }}
              >
                <div style={{ display: "flex", flexDirection: 'column' }}>
                  <div>
                    <input
                      id="input"
                      type="file"
                      accept="image/*"
                      name="file"
                      ref={fileInputForW9}
                      onChange={(e) => {
                        changeHandlerProfileImage(e)
                      }}
                    />
                  </div>

                  <div>
                    <p style={{ marginTop: '8px', fontSize: '12px' }}>Allowed only *.jpeg, *.jpg, *.png</p>
                  </div>
                </div>

                <div>
                  {isImgUrl !== null &&
                    <div>
                      <td style={{
                        color: 'blue',
                        width: '28%',
                        cursor: 'pointer'
                      }}
                        onClick={() => window.open(isImgUrl, "_blank")} href={isImgUrl}
                      >Download Logo</td>

                    </div>
                  }
                </div>
                <div>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744', marginLeft: '20px' }}
                    variant="contained"
                    color="error"
                    onClick={() => {
                      uploadFileForW9('COMPANY_LOGO');
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Box>
            <Box marginTop={'25px'}>
              <Stack direction="column" alignItems="self-start">
                <Typography variant="h5" gutterBottom component="div">
                  Vendor Convenience Fee
                </Typography>
                <TextField
                  sx={{ width: '90%' }}
                  placeholder="Vendor Convenience Fee"
                  value={values.convenienceFee}
                  onChange={handleChange}
                  disabled={allDisabled}
                  onBlur={handleBlur}
                  name={'convenienceFee'}
                  error={Boolean(touched.convenienceFee && errors.commission)}
                  helperText={touched.convenienceFee && errors.convenienceFee}
                />
              </Stack>
            </Box>

            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', marginRight: '100px' }}>
              <Button
                style={{
                  color: 'white',
                  backgroundColor: '#E23744',
                }}
                variant="contained"
                color="error"
                onClick={() => {
                  navigate('/dashboard');
                }}
                sx={{ marginRight: '10px' }}
                size="large"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleSubmit();
                }}
                size="large"
                type="submit"
                disabled={allDisabled}
              >
                Update
              </Button>
            </div>
          </Container>
        )}
      </Formik>
      {findByIdResponse.isLoading ||
        enumResponse.isLoading ||
        serviceProviderDetailResponse.isLoading ||
        uploadFormResponse.isLoading ? (
        <Loading />
      ) : null}
    </Page>
  );
}
